import { useState } from 'react';
import { useSelector } from 'react-redux';

import { Select } from '@anwb/poncho/components/forms';
import Grid from '@anwb/poncho/components/grid';
import { trackEvent } from '@anwb/poncho/utilities/tracking';

import { leaseCarUpgradesSelector } from '../../../../../../store/selectors';
import { Upgrade } from '../../../../../../types';

import { SelectedVehicleOptions } from './components/SelectedVehicleOptions';
import { UpgradeDescriptionList } from './components/UpgradeDescriptionList';

type Props = {
	upgrade: Upgrade;
};

export const EquipmentContentV2 = ({ upgrade }: Props) => {
	const upgrades: Upgrade[] = useSelector(leaseCarUpgradesSelector);
	const [value, setValue] = useState<number | undefined>(upgrade?.id);
	const selectedVehicle = upgrades.find((option) => option.id === value);

	if (!upgrade) {
		return null;
	}

	const handleSelect = (selectedValue: number) => {
		setValue(upgrades.find((option) => option.id === selectedValue)?.id);
		const fieldName = upgrades.find((option) => option.id === selectedValue)?.description;
		const indexValue = (upgrades.findIndex((option) => option.id === selectedValue) + 1).toString();

		trackEvent({
			event: 'user_interaction',
			type: 'form',
			component: 'dropdown',
			field: fieldName,
			action: 'open',
			actionValue: indexValue,
			funnel_name: 'private-lease-nieuw',
			funnel_step: 'samenstelling-auto-en-contract',
			funnel_index: '1',
		});
	};

	return (
		<Grid>
			{upgrades.length > 1 && (
				<Grid.Item>
					<Select
						onChange={(e) => handleSelect(Number(e.target.value))}
						reference="equipment-select"
						name="equipment-select"
						value={value}
					>
						{upgrades.map((option) => (
							<Select.Option key={option.id} value={option.id}>
								{option.description}
							</Select.Option>
						))}
					</Select>
				</Grid.Item>
			)}

			<UpgradeDescriptionList selectedVehicle={selectedVehicle} />
			<SelectedVehicleOptions selectedVehicle={selectedVehicle} />
		</Grid>
	);
};
